import {
  Users, CalendarDays, FileCheck2, Smartphone, GraduationCap, Video,
  Images, Briefcase, ClipboardList, KanbanSquare, BarChart3, Plug, Box,
} from "lucide-react";

const map = {
  Users, CalendarDays, FileCheck2, Smartphone, GraduationCap, Video,
  Images, Briefcase, ClipboardList, KanbanSquare, BarChart3, Plug,
};

export default function ProductIcon({ name, ...props }) {
  const Cmp = map[name] || Box;
  return <Cmp {...props} />;
}
